import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/nutrition-settings',
    redirectTo: '/nutrition-settings/diet-type',
  },
];

export default redirects;
